import React, { useRef, useEffect, useState } from "react";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import ChinaMapData from "../../../../assets/json/Wold.json";

// 注册中国地图数据
echarts.registerMap("China", ChinaMapData);

const ChinaMap3 = () => {
  const echartsRef = useRef(null);
  const [mouseenterValue, setMouseenterValue] = useState("");
  const [Lotus, setLotus] = useState("");

  const [ImgStyle, setImgStyle] = useState("");
  const HIGHLIGHT_REGIONS = [
    { name: "North Korea", color: "rgba(255, 0, 0, 0.46)" }, //
    { name: "China", color: "rgba(255, 0, 0, 0.46)" }, //Zhongguogudailian
    { name: "India", color: "rgba(255, 0, 0, 0.46)" }, //YinDuLian
    { name: "Thailand", color: "rgba(255, 0, 0, 0.46)" }, //ZhiGaoWuShang
    { name: "Indonesia", color: "rgba(255, 0, 0, 0.46)" }, //YinDuLian
    { name: "Japan", color: "rgba(255, 0, 0, 0.46)" }, //BaiShaoYaoLian
    { name: "Mexico", color: "rgba(255, 255, 0, 0.39)" }, //MeiZhouHuangLian
    { name: "United States", color: "rgba(255, 255, 0, 0.46)" }, //MeiZhouHuangLian
  ];
  useEffect(() => {
    const instance =
      echartsRef.current && echartsRef.current.getEchartsInstance();
    if (instance) {
      instance.setOption(getOption());

      // 定义鼠标移入事件处理函数
      const handleMouseOver = (params) => {
        const region = HIGHLIGHT_REGIONS.find((r) => r.name === params.name);
        console.log("region:", region);
        if (region) {
          if (region.color === "rgba(255, 255, 0, 0.46)") {
            // return `${params.name} American Lotus`;
            console.log("params:", params.name + " American Lotus");
            if (params.name === "United States" || params.name === "Mexico") {
              //  setimgSrc( './img/美洲黄莲.JPG')
              // setimgSrc(
              //   "/api/static/GermplasmInformation/2ad8fcd6-7e92-443e-a911-080ef0a3f28b.JPG"
              // );
              setImgStyle("美洲黄莲");
              setMouseenterValue(params.name);
              setLotus("American Lotus");
            }
          } else if (region.color === "rgba(255, 0, 0, 0.46)") {
            // return `${params.name} Asian Lotus`;
            console.log("params:", params.name);
            if (params.name == "China") {
              // setimgSrc(
              //   "/api/static/GermplasmInformation/2b28a5f6-d162-4a60-a296-c85e6ba484f1.JPG"
              // );
              // setimgSrc('./img/中国古代莲.JPG')
              setImgStyle("中国古代莲");
              setMouseenterValue(params.name);
              setLotus("Asian Lotus");

            }
            if (params.name == "India") {
              // setimgSrc(
              //   "/api/static/GermplasmInformation/ffb90233-498e-4fbd-9cdf-b9104cd0d545.jpg"
              // );
              // setimgSrc('./img/印度莲.jpg')
              setImgStyle("印度莲");
              setMouseenterValue(params.name);
              setLotus("Asian Lotus");
            }
            if (params.name == "Thailand") {
              // setimgSrc(
              //   "/api/static/GermplasmInformation/bb061120-1b84-47d3-a025-bbcc13ea3652.JPG"
              // );
              // setimgSrc('./img/至高无上.JPG')
              setImgStyle("至高无上");
              setMouseenterValue(params.name);
              setLotus("Asian Lotus");

            }
            if (params.name == "Indonesia") {
              // setimgSrc("/api/static/GermplasmInformation/ffb90233-498e-4fbd-9cdf-b9104cd0d545.jpg")
              // setimgSrc('./img/印度莲.jpg')
              setImgStyle("印度莲");
              setMouseenterValue(params.name);
              setLotus("Asian Lotus");

            }
            if (params.name == "Japan") {
              // setimgSrc("/api/static/GermplasmInformation/6db29756-373e-4937-ab63-8bf33f8b8e72.png")
              // setimgSrc('./img/白芍药莲.png')
              setImgStyle("白芍药莲");
              setMouseenterValue(params.name);
              setLotus("Asian Lotus");

            }
          }
        }
        // 可以在这里添加更多的逻辑，比如改变样式等
      };

      // 定义鼠标移出事件处理函数
      const handleMouseOut = (params) => {
        console.log("鼠标移出:", params.name);
        setImgStyle(""); // 重置图片样式状态
        setMouseenterValue("");
      };

      // 添加鼠标移入事件监听
      instance.on("mouseover", handleMouseOver);
      // 添加鼠标移出事件监听
      instance.on("mouseout", handleMouseOut);

      // 组件卸载时移除事件监听
      return () => {
        instance.off("mouseover", handleMouseOver);
        instance.off("mouseout", handleMouseOut);
      };
    }
  }, []);

  // 工具提示格式化函数
  const tooltipFormatter = (params) => {
    console.log("params:", params);
    const region = HIGHLIGHT_REGIONS.find((r) => r.name === params.name);
    console.log("region:", region);
    if (region) {
      if (region.color === "rgba(255, 255, 0, 0.46)") {
        return `${params.name} American Lotus`;
      } else if (region.color === "rgba(255, 0, 0, 0.46)") {
        return `${params.name} Asian Lotus`;
      }
    }
    return `${params.name}`;
  };

  // 生成 ECharts 配置项
  const getOption = () => {
    return {
      tooltip: {
        trigger: "item",
        formatter: tooltipFormatter,
      },
      geo: {
        map: "China",
        roam: true,
        zoom: 1.2,
        
        label: {
          emphasis: {
            show: false,
          },
        },
        regions: HIGHLIGHT_REGIONS.map((region) => ({
          name: region.name,
          itemStyle: {
            areaColor: region.color,
            borderColor: region.color,
            borderWidth: 2,
          },
          emphasis: {
            itemStyle: {
              areaColor: region.color,
              borderColor: region.color,
              borderWidth: 2,
            },
          },
        })),
      },
      series: [
        {
          name: "标记点",
          type: "scatter",
          coordinateSystem: "geo",
          symbol: "pin",
          symbolSize: 20,
          label: {
            show: false,
          },
        },
      ],
    };
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <ReactEcharts
        option={getOption()}
        style={{ height: "70%", width: "100%" }}
        ref={echartsRef}
      />
      <div
        style={{
          width: "100%",
          // height: "20%",
          textAlign: "center",
          fontSize: "16px",
          marginBottom: "5px",
        }}
      >
        <p
          style={{
            height: "20px",
            margin: "15px 0",
            color: mouseenterValue ? "black" : "transparent",
          }}
        >
          <span>{mouseenterValue}</span>
          <span>{Lotus}</span>
        </p>
       
        <div
          style={{
            width: "80%",
            display: "flex",
            justifyContent: "space-around",
            margin: "auto",
          }}
        >
          <img
            src={require("./img/中国古代莲.JPG")}
            style={{
              transform: ImgStyle === "中国古代莲" ? "scale(1.5)" : "scale(1)",
              transition: "transform 0.3s ease-in-out",
              margin: "5px",
              width: "10%",
              height: "60%",

              zIndex: ImgStyle === "中国古代莲" ? 1 : 0,
            }}
            alt=""
          />
          <img
            src={require("./img/印度莲.jpg")}
            style={{
              transform: ImgStyle === "印度莲" ? "scale(1.5)" : "scale(1)",
              transition: "transform 0.3s ease-in-out",
              margin: "5px",
              width: "10%",
              height: "60%",

              zIndex: ImgStyle === "印度莲" ? 1 : 0,
            }}
            alt=""
          />
          <img
            src={require("./img/至高无上.JPG")}
            style={{
              transform: ImgStyle === "至高无上" ? "scale(1.5)" : "scale(1)",
              transition: "transform 0.3s ease-in-out",
              margin: "5px",
              width: "10%",
              height: "60%",

              zIndex: ImgStyle === "至高无上" ? 1 : 0,
            }}
            alt=""
          />
          <img
            src={require("./img/白芍药莲.png")}
            style={{
              transform: ImgStyle === "白芍药莲" ? "scale(1.5)" : "scale(1)",
              transition: "transform 0.3s ease-in-out",
              margin: "5px",
              width: "10%",
              height: "60%",

              zIndex: ImgStyle === "白芍药莲" ? 1 : 0,
            }}
            alt=""
          />
          <img
            src={require("./img/美洲黄莲.JPG")}
            style={{
              transform: ImgStyle === "美洲黄莲" ? "scale(1.5)" : "scale(1)",
              transition: "transform 0.3s ease-in-out",
              margin: "5px",
              width: "10%",
              height: "60%",

              zIndex: ImgStyle === "美洲黄莲" ? 1 : 0,
            }}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default ChinaMap3;
